@if (loading()) {
  <div class="partner-referrals__loading" role="status" aria-label="Carregando">
    <app-cog-loading-spinner [size]="48" />
  </div>
} @else if (errorMessage()) {
  <div class="partner-referrals__error" role="alert">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <p>{{ errorMessage() }}</p>
    <app-button
      label="Tentar de novo"
      icon="pi pi-refresh"
      theme="white"
      [type]="'button'"
      (sendButtonClick)="load()" />
  </div>
} @else if (links()) {
  <section class="partner-referrals__card">
    <h3 class="partner-referrals__title">Indicado por</h3>
    @if (links()?.referredBy; as referredBy) {
      <div class="partner-referrals__referred-by">
        <strong>{{ referredBy.partnerName }}</strong>
        <span>
          @if (referredBy.userName) {
            link de {{ referredBy.userName }} ·
          }
          via {{ channelLabel(referredBy.channel) }} · cadastro em
          {{ referredBy.referredAt | vaultDateTime }}
        </span>
      </div>
    } @else {
      <p class="partner-referrals__muted">Cadastro direto, sem indicação.</p>
    }
  </section>

  <section class="partner-referrals__card">
    <h3 class="partner-referrals__title">Quem ele indicou ({{ referred().length }})</h3>
    @if (referred().length) {
      <app-table
        [items]="referred()"
        [columnDefinitions]="columnDefinitions"
        [dataKey]="'partnerId'"
        [hasPagination]="referred().length > 15"
        [inMemoryPagination]="true"
        [rows]="15"
        [rowsPerPageOptions]="[15, 30, 50, 100]">
        <ng-template appNamedTemplate="partnerName" let-item>
          <div class="partner-referrals__who">
            <strong>{{ item.partnerName }}</strong>
            <span>{{ detail(item) }}</span>
            @if (item.referredByUserName) {
              <span>link de {{ item.referredByUserName }}</span>
            }
          </div>
        </ng-template>

        <ng-template appNamedTemplate="channel" let-item>
          {{ channelLabel(item.channel) }}
        </ng-template>

        <ng-template appNamedTemplate="referredAt" let-item>
          {{ item.referredAt | vaultDateTime }}
        </ng-template>

        <ng-template appNamedTemplate="status" let-item>
          <span
            class="partner-referrals__tag"
            [class.partner-referrals__tag--info]="item.status === 'SignedUp'"
            [class.partner-referrals__tag--success]="item.status === 'DealGenerated'">
            {{ statusLabel(item.status) }}
          </span>
        </ng-template>
      </app-table>
    } @else {
      <p class="partner-referrals__muted">
        Nenhum parceiro se cadastrou pelos links de indicação dos usuários deste parceiro.
      </p>
    }
  </section>
}
